import { WHY_PRINCIPLES } from "../../data/content";
import { ChapterLabel, Container, FadeUp, MaskedLine } from "./ui";

const WhyInvogue = () => (
  <section className="bg-ink py-28 md:py-40" data-testid="why-section">
    <Container>
      <ChapterLabel num="08" label="Why InVogue" />
      <h2 className="mt-10 font-serif font-medium leading-[0.95] text-ivory text-[clamp(40px,5.4vw,84px)]">
        <MaskedLine delay={0.1}>CE QUE VOUS ACHETEZ</MaskedLine>
        <MaskedLine delay={0.2} className="text-champagne">
          VRAIMENT.
        </MaskedLine>
      </h2>

      <div className="mt-16 md:mt-24">
        {WHY_PRINCIPLES.map((p, i) => (
          <FadeUp key={p.num} delay={i * 0.08}>
            <div
              className="grid gap-4 border-t border-line py-10 last:border-b md:grid-cols-12 md:items-baseline md:gap-8 md:py-12"
              data-testid={`why-${p.num}`}
            >
              <span className="font-serif text-[44px] font-medium leading-none text-champagne/60 md:col-span-2 md:text-[56px]">
                {p.num}
              </span>
              <h3 className="font-display text-[13px] font-semibold tracking-[0.26em] text-ivory md:col-span-3">
                {p.title}
              </h3>
              <p className="max-w-[520px] font-sans text-[15px] font-light leading-[1.8] text-neutral-400 md:col-span-7 md:text-base">
                {p.text}
              </p>
            </div>
          </FadeUp>
        ))}
      </div>
    </Container>
  </section>
);

export default WhyInvogue;
